import { render } from "./OpenAccessToSupportModal.vue?vue&type=template&id=540bb078"
import script from "./OpenAccessToSupportModal.vue?vue&type=script&lang=ts"
export * from "./OpenAccessToSupportModal.vue?vue&type=script&lang=ts"
script.render = render

export default script